import React, { Component } from 'react';
import $ from 'jquery';

import next from '../../../static/image/v2/next.png';
import prev from '../../../static/image/v2/prev.png';

class PageBtnV2 extends Component {
  pageBtnLLink = (e) => {
    let dataset = e.currentTarget.dataset
    let index = dataset.index
    let url = this.props.url

    if(url === '/v2/review') {
      var shopId = $('.shopSelectText').attr('data-id');
      var name = $('#nameInput').val();
      var startDate = $('#startDate').val();
      var endDate = $('#endDate').val();
      var dayType = $('.daySelectText').attr('data-type');
      
      window.location.href = `/v2/review?shopSelect=${ shopId }&name=${ name }&startDate=${ startDate }&endDate=${ endDate }&page=${ index }&dayType=${ dayType }`
    } else if(url === '/v2/coupon') {
      var shopId = $('.shopSelectText').attr('data-id');
      var type = $('.selectText1').attr('data-type');
      var name = '';
      var create = '';
      var cost = '';
      var states = $('.selectText2').attr('data-type');
      var dayType = $('.selectText1').attr('data-type');
      
      if(type === '1') {
        name = $('.searchTextInput').val()
      } else if(type === '2') {
        create = $('#startDate').val()
      } else if(type === '3') {
        cost = $('.searchTextInput').val()
      }
      window.location.href = `/v2/coupon?shopSelect=${ shopId }&name=${ name }&create=${ create }&cost=${ cost }&page=${ index }&type=${ dayType }&states=${ states }`
    }
  }

  componentDidUpdate(_, prevState) {
    let listCount = Number(this.props.listCount);
    let count = Number(this.props.count);
    let page = Number(this.props.page);
    let paging = 0;
    let prevListCount = prevState.listCount;
    let prevCount = prevState.count;
    let prevPage = prevState.page;

    if(listCount !== prevListCount || count !== prevCount || page !== prevPage) {
      if(listCount !== '') {
        var result = parseInt(listCount / count);
        var remainder = listCount % count;
  
        if(remainder !== 0) {
          paging = result;
        } else {
          paging = result - 1;
        }
  
  
        var pageList = []
  
        if(page <= 2) {
          pageList = [1, 2, 3, 4, 5]
        } else if(page >= paging - 2) {
          var number = [-3, -2, -1, 0, 1]

          for(var i = 0; number.length > i; i++) {
            if(paging + number[i] > 0) {
              pageList.push(paging + number[i])
            }
          }
        } else {
          pageList = [page - 1, page, page + 1, page + 2, page + 3]
        }
  
        $('.pageList').empty()
        $('.lastPageBtn').attr('data-index', paging)

        for(var i = 0; pageList.length > i; i++) {
          var li = document.createElement('li');
          if(paging + 1 >= pageList[i]) {
            if(page + 1 === pageList[i]) {
              li.innerHTML = `<button data-index='${pageList[i] - 1}' class='active pageBtn'>${pageList[i]}</button>`
            } else {
              li.innerHTML = `<button data-index='${pageList[i] - 1}' class='pageBtn'>${pageList[i]}</button>`
            }
            li.setAttribute('class', 'pagingBtn')
            
            li.querySelector('.pageBtn').addEventListener('click', (e) => {
              let dataset = e.currentTarget.dataset
              let index = dataset.index
              let url = this.props.url

              if(url === '/v2/review') {
                var shopId = $('.shopSelectText').attr('data-id');
                var name = $('#nameInput').val();
                var startDate = $('#startDate').val();
                var endDate = $('#endDate').val();
                var dayType = $('.daySelectText').attr('data-type');
                
                window.location.href = `/v2/review?shopSelect=${ shopId }&name=${ name }&startDate=${ startDate }&endDate=${ endDate }&page=${ index }&dayType=${ dayType }`
              } else if(url === '/v2/coupon') {
                var shopId = $('.shopSelectText').attr('data-id');
                var type = $('.selectText1').attr('data-type');
                var name = '';
                var create = '';
                var cost = '';
                var states = $('.selectText2').attr('data-type');
                var dayType = $('.selectText1').attr('data-type');
                
                if(type === '1') {
                  name = $('.searchTextInput').val()
                } else if(type === '2') {
                  create = $('#startDate').val()
                } else if(type === '3') {
                  cost = $('.searchTextInput').val()
                }
                
                window.location.href = `/v2/coupon?shopSelect=${ shopId }&name=${ name }&create=${ create }&cost=${ cost }&page=${ index }&type=${ dayType }&states=${ states }`
              }
            })

            $('.pageList').append(li)
          }
        }
      }
      
      this.setState({ listCount: listCount, count: count, page: page })
    }
  }

  constructor(props) {
    super(props)

    let listCount = Number(this.props.listCount);
    let count = Number(this.props.count);
    let page = Number(this.props.page);

    this.state = {
      listCount: listCount,
      count: count,
      page: page
    }
  }

  render() {
    return (
      <div className='pagingBox'>
        <button data-index='0' className='pageBtn firstPageBtn' onClick={ this.pageBtnLLink }>
          <img src={ prev } />
        </button>
        <ul className='pageList'>

        </ul>
        <button data-index='0' className='pageBtn lastPageBtn' onClick={ this.pageBtnLLink }>
          <img src={ next } />
        </button>
      </div>
    )
  }
}

export { PageBtnV2 }